import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export interface DashboardStats {
  users: {
    total: number;
    activeToday: number;
    activeThisWeek: number;
    newThisMonth: number;
  };
  receipts: {
    today: number;
    approvalRate: number;
    totalThisMonth: number;
  };
  orders: {
    pendingPickup: number;
    totalRevenue: number;
    totalThisMonth: number;
  };
  checkins: {
    lastMatch: {
      matchId: string;
      matchName: string;
      total: number;
      withGeo: number;
      withoutGeo: number;
    } | null;
  };
  topSponsors: Array<{
    sponsorId: string;
    name: string;
    receiptCount: number;
    totalValue: number;
    score: number;
  }>;
  nextMatch: {
    id: string;
    homeTeamName: string;
    awayTeamName: string;
    homeTeamLogo: string | null;
    awayTeamLogo: string | null;
    date: string;
    daysUntil: number;
  } | null;
}

export interface UsersGrowthRow {
  date: string;
  newUsers: number;
  totalUsers: number;
}

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: async () => {
      const res = await apiClient.get<DashboardStats>('/dashboard/stats');
      return res.data;
    },
    refetchInterval: 60_000,
  });
}

export function useUsersGrowth() {
  return useQuery({
    queryKey: ['dashboard', 'users-growth'],
    queryFn: async () => {
      const res = await apiClient.get<{ data: UsersGrowthRow[] }>('/dashboard/users-growth');
      return res.data.data;
    },
  });
}
